import React, { useEffect, useState } from 'react';
import ApexCharts from 'apexcharts';
import api from 'api';

const StatisticsCategory = () => {
  const [startDate, setStartDate] = useState(new Date().toISOString().split('T')[0]);
  const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  // 부문별 매출 데이터 조회
  const fetchCategorySales = async (start, end) => {
    setLoading(true);
    try {
      const response = await api.get(`/statistics/category?startDate=${start}&endDate=${end}`);
      setData(response);
    } catch (error) {
      console.error('부문별 매출 조회 실패:', error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategorySales(startDate, endDate);
  }, [startDate, endDate]);

  useEffect(() => {
    // 파이 차트 (판매액 비율)
    if (data.length === 0) return;

    const options = {
      series: data.map(d => Math.floor(d.sales / 100000)), // 단위: 만원
      labels: data.map(d => d.category),
      chart: {
        type: 'donut',
        height: 350,
      },
      colors: ['#4154f1', '#2eca6a', '#ff771d', '#ffc107', '#e74c3c', '#9b59b6'],
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val.toFixed(1) + '%';
        },
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return '¥' + (val * 100000).toLocaleString('ko-KR');
          },
        },
      },
    };

    const chart = new ApexCharts(document.querySelector('#categoryChart'), options);
    chart.render();

    return () => {
      chart.destroy();
    };
  }, [data]);

  const handleSearch = () => {
    fetchCategorySales(startDate, endDate);
  };

  // 판매액 순으로 정렬
  const sortedData = [...data].sort((a, b) => b.sales - a.sales);

  return (
    <div className="row">
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">부문별 매출 현황 (매입구분 기준)</h5>

          <div className="row mb-3">
            <div className="col-sm-2">
              <label htmlFor="startDate" className="form-label">
                시작일:
              </label>
              <input
                id="startDate"
                type="date"
                className="form-control"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className="col-sm-1" style={{ textAlign: 'center', paddingTop: '35px' }}>
              ~
            </div>
            <div className="col-sm-2">
              <label htmlFor="endDate" className="form-label">
                종료일:
              </label>
              <input
                id="endDate"
                type="date"
                className="form-control"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
            <div className="col-sm-2" style={{ paddingTop: '35px' }}>
              <button type="button" className="btn btn-primary" onClick={handleSearch}>
                조회
              </button>
            </div>
            <div className="col-sm-5">&nbsp;</div>
          </div>

          <div className="row">
            <div className="col-lg-6">
              {loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">로딩 중...</span>
                  </div>
                </div>
              ) : (
                <div id="categoryChart"></div>
              )}
            </div>
            <div className="col-lg-6">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th scope="col">부문</th>
                    <th scope="col">판매액</th>
                    <th scope="col">판매량</th>
                    <th scope="col">점유율</th>
                  </tr>
                </thead>
                <tbody>
                  {sortedData.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <strong>{item.category}</strong>
                      </td>
                      <td>¥{item.sales.toLocaleString('ko-KR')}</td>
                      <td>{item.quantity}</td>
                      <td>
                        <span className="badge bg-info">{item.rate}%</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="alert alert-info mt-3" role="alert">
            <strong>참고:</strong> 본 통계는 상품의 매입구분을 기준으로 부문별 판매 현황을 보여줍니다.
            실제 데이터는 Product List의 매입구분 필드를 기준으로 집계됩니다.
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatisticsCategory;
